import { SORT_FUNCTION } from '../common/constants';
import fileSorters from './fileSorters';

let LOCALE_COMPARE_OPTIONS = { numeric: true, sensitivity: 'base' };
export default {
  /**
   * Compares two users' last names and first names.
   *
   * @param {Object} u1 - The first user to compare.
   * @param {Object} u2 - The second user to compare.
   * @return {number} Returns a negative number if u1 should come before u2,
   *                  a positive number if u1 should come after u2,
   *                  or 0 if u1 and u2 are equal.
   */
  compareLastNameAndFirstName(u1, u2) {
    // Constants for comparison clarity
    const LOCALE_COMPARE_OPTIONS = { sensitivity: 'base' };
    const FIRST_IF_NULL = -1;
    const SECOND_IF_NULL = 1;

    // Handling null lastnames - Users with no lastname go to the bottom
    if (!u1.lastname && !u2.lastname) {
      // Both have no lastname, compare by firstname
      return u1.firstname.localeCompare(u2.firstname, undefined, LOCALE_COMPARE_OPTIONS);
    }
    if (!u1.lastname) return 1; // u1 goes to bottom
    if (!u2.lastname) return -1; // u2 goes to bottom

    // Both have lastnames, proceed to compare
    let lastNameComparison = u1.lastname.localeCompare(u2.lastname, undefined, LOCALE_COMPARE_OPTIONS);
    if (lastNameComparison !== 0) return lastNameComparison;

    // Lastnames are equal, compare firstnames but prioritize nulls to be first
    if (!u1.firstname && !u2.firstname) return 0; // Both firstnames are null, keep order
    if (!u1.firstname) return FIRST_IF_NULL; // u1 without firstname should come first
    if (!u2.firstname) return SECOND_IF_NULL; // u2 without firstname should come first

    // Both have firstnames, proceed to compare
    return u1.firstname.localeCompare(u2.firstname, undefined, LOCALE_COMPARE_OPTIONS);
  },

  /**
   * usage sortFunctions.sort(items,sortableField,options)
   * @returns
   * @param items
   * @param sortableField
   * @param options
   */
  sort(items, sortableField, options) {
    return items.sort((a, b) => this.compareValues(a[sortableField], b[sortableField], options));
  },

  isNumber(a) {
    return !isNaN(a);
  },
  /**
   * Returns -1 if a is lower than b, 1 if a is greater than b, 0 if both values equals
   * Null, undefined and empty strings and Illegal date strings follow valid ones
   * @param {*} a string, Number or parseable Date string
   * @param {*} b string, Number or parseable Date string
   * @param {*} options - Object of optional properties with order=asc|desc and isParseableDateString=true to make the function use Date.parse([value])
   * @returns -1, 0, 1
   */
  compareValues(a, b, options) {
    let order, isParseableDateString, isAsc;

    if (!options) {
      order = 'asc';
      isParseableDateString = false;
    } else {
      order = options.order;
      isParseableDateString = options.isParseableDateString;
    }

    isAsc = order === 'asc';

    if (this.isUndefined(a)) return isAsc ? 1 : -1;

    if (this.isUndefined(b)) return isAsc ? -1 : 1;

    if (isParseableDateString) {
      if (a === b) return 0;
      let aParsed = Date.parse(a);
      let bParsed = Date.parse(b);
      if (isNaN(aParsed)) return isAsc ? 1 : -1;
      if (isNaN(bParsed)) return isAsc ? -1 : 1;

      return aParsed < bParsed ? (isAsc ? 1 : -1) : isAsc ? -1 : 1;
    }

    // if (this.isNumber(a) && this.isNumber(b)) {
    //   console.debug(`compare number values  <${a}> <${b}>`);
    //   return Number(a) > Number(b) ? (isAsc ? 1 : -1) : isAsc ? -1 : 1;
    // }
    //if (typeof a === 'string' && typeof b === 'string') {

    // console.debug(`locale compare values <${a}> <${b}>`);
    //return isAsc ? `${a}`.localeCompare(`${b}`) : `${b}`.localeCompare(`${a}`);
    return isAsc ? `${a}`.localeCompare(`${b}`, undefined, LOCALE_COMPARE_OPTIONS) : `${b}`.localeCompare(`${a}`, undefined, LOCALE_COMPARE_OPTIONS);
  },

  isUndefined(value) {
    return value === null || value === undefined;
  },

  sortBySorter(documents, sorterName) {
    let sorted;
    switch (sorterName) {
      case SORT_FUNCTION.BY_DATE_UPDATED_DESC:
        sorted = this.sort(documents, 'dateupdated', { order: 'desc' });
        break;
      case SORT_FUNCTION.BY_SORT_FIELD:
        sorted = documents.sort(fileSorters.bySortField);
        break;
      case SORT_FUNCTION.BY_SORT_FIELD_DESC:
        sorted = documents.sort(fileSorters.bySortFieldDesc);
        break;
      case SORT_FUNCTION.BY_IMPORTANCE:
        sorted = documents.sort(fileSorters.byImportance);
        break;
      case SORT_FUNCTION.BY_ALPHABETIC_DESC:
        sorted = this.sort(documents, 'title', { order: 'desc' });
        break;
      default:
        sorted = this.sort(documents, 'title', { order: 'asc' });
    }
    return sorted;
  },
};
